import { StorefrontLayout } from "@/components/StorefrontLayout";

export function Placeholder({ title, message }: { title: string; message: string }) {
  return (
    <StorefrontLayout>
      <div className="flex flex-col items-center gap-3 px-6 py-24 text-center">
        <h1 className="font-display text-xl font-medium text-ink">{title}</h1>
        <p className="text-sm text-stone-500">{message}</p>
      </div>
    </StorefrontLayout>
  );
}
